import Basic from './Basic';
import Setting from './Setting';
import StateItem from './StateItem';

export default {
  Basic,
  StateItem,
  Setting
};
